import { getDataOrNull } from "@msys/common";
import { InvitationTokenData } from "./InvitationTokenData.js";
import { RefTokenQuery } from "./InvitationTokenProvider.generated.js";

// `organisationMembershipInvitation` sits behind an extra wrapper object
// (`OrganisationMembershipInvitationQueryResult`) whose non-null `result`
// field is itself the union of the pending invitation and the data-free
// `InvitationNoLongerOpen` member — unwrap both levels here. All invitation
// types share the same `i_<token>` envelope, so the backend resolves
// `InvitationNoLongerOpen` for ANY refToken without a pending membership
// row, even when that token actually belongs to a CRM linking invitation.
// A genuine sibling match must therefore win over that fallback: try the
// pending membership invitation first, then the CRM linking invitation,
// then a referral, and only once none of those match does
// `InvitationNoLongerOpen` apply — i.e. a membership link that is truly
// spent, or a link that matches no live invitation at all.
export function resolveInvitationTokenData(
  data: RefTokenQuery | undefined
): InvitationTokenData | null {
  const organisationMembershipInvitationResult = getDataOrNull(
    data?.organisationMembershipInvitation
  )?.result;
  const pendingOrganisationMembershipInvitation =
    organisationMembershipInvitationResult?.__typename ===
    "OrganisationMembershipInvitation"
      ? organisationMembershipInvitationResult
      : null;

  return (
    pendingOrganisationMembershipInvitation ??
    data?.crmLinkingInvitation ??
    data?.referralInfo ??
    organisationMembershipInvitationResult ??
    null
  );
}
